import { defineMessages } from 'react-intl';

export const evidenceImageBlockMessages = defineMessages({
  fallbackAlt: {
    id: 'mz1Sw27jVB',
    defaultMessage: 'Image {n}',
    description: 'Fallback alt text when an evidence image has no description',
  },
  closePreview: {
    id: 'UZcUmiRYVf',
    defaultMessage: 'Close image preview',
    description:
      'Accessible label for the lightbox backdrop that closes the evidence image preview',
  },
  close: {
    id: 'w5dXWx3rNZ',
    defaultMessage: 'Close',
    description:
      'Accessible label for the button that closes the evidence image lightbox',
  },
  viewFullWithDescription: {
    id: 'WgXpCW0A8g',
    defaultMessage: 'View full image: {description}',
    description:
      'Accessible label to open the evidence image lightbox with a description',
  },
  viewFullByNumber: {
    id: 'FLsmqp0a7n',
    defaultMessage: 'View full image {n}',
    description: 'Accessible label to open the evidence image lightbox by image number',
  },
  captionWithDescription: {
    id: 'QQ+dlP0RBc',
    defaultMessage: '<imageLabel>Image {n}:</imageLabel> {description}. Source: {source}',
    description: 'Caption under an evidence image with description and source hostname',
  },
  captionSourceOnly: {
    id: '/GYmuCwK6K',
    defaultMessage: '<imageLabel>Image {n}:</imageLabel> Source: {source}',
    description: 'Caption under an evidence image with only the source hostname',
  },
});
